import { Component, ElementRef, ViewChild, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';

import { FestivoModel } from './Festivo.model';

import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { ConfirmarEliminacionService } from '../Dialog/ConfirmarEliminacionService';



@Component({
	selector : 'festivo',
	templateUrl : './FestivoIndex.component.html',
	styleUrls  : ['../../../../styles.css']
})

/**
* @author Camilo
* @since  31/10/2017
**/
export class FestivoIndexComponent {
	
	// ~~~~~ Variables para el manejo de permisos ~~~~~ //
	public btnAgregar:boolean;
	public btnEditar:boolean;
	public btnEliminar:boolean;
	public btnConsultar:boolean;
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //
	
	public festivos:Array<FestivoModel>;
	public guardando:boolean;

	public nano: string;

	public form: FormGroup;
	public displayedColumns = ['FECHA', 'BLOQUEAR'];
	public dataDataBase:FestivosDatabase;
	public dataSource:ExampleDataSource;

	public ocultar: boolean = false;
	public mensaje: string = "";	
	public formErrors: any;

	@ViewChild('filter') filter: ElementRef;


	constructor(private formBuilder: FormBuilder,private _serviciosGenerales:ServiciosGenerales, public snackBar: MatSnackBar,
		private _route: ActivatedRoute, private _router:Router, public dialog: MatDialog, 
		private confirmarEliminacionService:ConfirmarEliminacionService)
	{
		this.festivos = new Array();
		this.guardando = false;

		this.nano = "";

		this.formErrors = {
			nano: {}
		};

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnAgregar = _serviciosGenerales.seguridad.isAgregar();
		this.btnEditar = _serviciosGenerales.seguridad.isEditar();
		this.btnEliminar = _serviciosGenerales.seguridad.isEliminar();
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.snackBar.dismiss();
	}

	ngOnInit()
	{

		this.form = this.formBuilder.group({
			mes: ['', Validators.required],
			nano: ['', Validators.required]
		});

		//this.cargarTabla();
	}

	private cargarTabla(message: string){
		this.dataDataBase = new FestivosDatabase();
		
		this._serviciosGenerales.get('consultarFestivos', {nano:message}).subscribe(
			result =>{
				console.log(result)
				this.festivos = new Array();
				for(let x of result){
					
					let festivoModel: FestivoModel = new FestivoModel(x.BLOQUEAR, x.DFECHA);
					
					this.dataDataBase.addFestivo(
						festivoModel
						);
				}
				this.dataSource = new ExampleDataSource(this.dataDataBase);
			}, 
			error =>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los festivos", "X");
			}
			);
	}

public registrarAnios() {
	
	 const nanoE = this.form.get('nano').value;
	 console.log(	'nanoE', nanoE);

	const yearAct = new Date().getFullYear();

	if (yearAct>parseInt(nanoE)){	
		this.openSnackBarEspecial("Ingrese un año actual o mayor al actual", "X");
			return "";
		}
		
	if (yearAct+5<parseInt(nanoE)){	
		this.openSnackBarEspecial("Ingrese un año no mayor a 5 años", "X");
		return "";
	}

	console.log('Enviar');

	this._serviciosGenerales.post('cargarFestivos/'+nanoE, {
		}).subscribe(
		result => {
			if(result.info =='0'){
				this.openSnackBarEspecial("Error en el servicio, por favor contacte al administrador", "X");
				return ;
			}else{
				this.openSnackBar("Festivos cargados correctamente para el año "+nanoE, "X");
				//cargar tabla
				this.cargarTabla(nanoE);
			}
			
		},
		error => {
			var errorMensaje = <any>error;
			console.log('Error al enviar la peticion ', errorMensaje);
		});	

}

		openSnackBar(message: string, action: string)
		{
			this.snackBar.open(message, action, {
				duration: 20000
			});
		}

		openSnackBarEspecial(message: string, action: string) {
			let snackBarRef =  this.snackBar.open(message, action);
	
			snackBarRef.onAction().subscribe(() => {
				console.log("Paso por aqui 1 notas");
	
				this.ocultar = false;
				this.mensaje = "";
			});
			
			let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
			
			if (shand.length != 0) {
					for (let i=0;i<shand.length;i++){
					shand[i].style.backgroundColor = "rgb(255 204 214)";
					}
				}
		}

	}




// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

export class FestivosDatabase
{
	
	dataChange: BehaviorSubject<FestivoModel[]> = new BehaviorSubject<FestivoModel[]>([]);

	get data(): FestivoModel[]
	{
		return this.dataChange.value;
	}

	addFestivo(festivo:FestivoModel)
	{
		const copiedData = this.data.slice();
		copiedData.push(festivo);
		this.dataChange.next(copiedData);
	}

	

}


export class ExampleDataSource extends DataSource<any>
{
	_filterChange = new BehaviorSubject('');

	get filter(): string
	{
		return this._filterChange.value;
	}

	set filter(filter: string)
	{
		this._filterChange.next(filter);
	}

	constructor(private _exampleDatabase: FestivosDatabase)
	{
		super();
	}

	/** Connect function called by the table to retrieve one stream containing the data to render. */
	connect(): Observable<FestivoModel[]>
	{
		const displayDataChanges = [
		this._exampleDatabase.dataChange,
		this._filterChange
		];

		return Observable.merge(...displayDataChanges).map(() => {
			return this._exampleDatabase.data.slice().filter((item: FestivoModel) => {
				return true;
			});
		});
	}

	disconnect()
	{
	}

	
}

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //
@Component({
	selector: 'confirmacionDeleteFestivo',
	templateUrl: 'confirmacionDeleteFestivo.html',
})
export class DialogConfirmacion {
	
	constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/RegistrarFestivos/FestivoIndex.component.ts